<div class="addin-root">
	<app-dashboard></app-dashboard>
</div>